module.exports = __webpack_public_path__ + "static/media/titan-card-back.ae50334c.png";